function extendFormData(props) {
  const { formData, schema } = props;
  if (!formData) {
    return props;
  }
  const copies = [];
  Object.keys(schema.properties).forEach((property) => {
    if (schema.properties[property] && schema.properties[property].query) {
      copies.push({ from: schema.properties[property].query, to: property });
    }
  });
  copies.forEach((copy) => {
    formData[copy.to] = formData[copy.from];
  });
  return { ...props, formData };
}

export default extendFormData;



// WEBPACK FOOTER //
// ./src/byob-cms/src/formLib/extendFormData.js